import * as React from 'react';

import { slugify } from 'gossamer-unified';
import styles from './Section.module.css';
import { ErrorBoundary } from '../ancillary/ErrorBoundary';

interface SectionProps {
  children?: React.ReactNode;
  id?: string;
  subtitle?: string;
  style?: React.CSSProperties;
  title?: string;
}

export const Section: React.FC<SectionProps> = (props) => {
  return (
    <section
      className={styles.Section}
      id={props.id || (props.title ? slugify(props.title) : 'main')}
      style={props.style}
    >
      <ErrorBoundary>
        {props.title && <h4>{props.title}</h4>}
        {props.subtitle && <p className="small">{props.subtitle}</p>}
        {props.children}
      </ErrorBoundary>
    </section>
  );
};
